import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { SessionActions } from '../session/session-actions';
import { createAction } from '../create-action';
import { CurrentScorecardActions } from './current-scorecard-actions';
import { map } from 'rxjs/operators';
import { createEffect } from 'node_modules/@ngrx/effects';
/**
 * Created by ashok on 11/05/17.
 */

@Injectable()
export class CurrentScorecardEffects {
    constructor(private actions$: Actions) {
        // alert("CurrentScorecardEffects")
    }
    //On logout clear the current scorecard
    // @Effect()
    // logout$ = this.actions$.pipe(ofType(SessionActions.LOGOUT))
    //     .pipe(map(()=>{
    //         return createAction(CurrentScorecardActions.CLEAR_CURRENT_SCORECARD);
    //     }));


    // logout$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(SessionActions.LOGOUT),
    //         map(() => {
    //             alert("CurrentScorecardEffects_logout")

    //             return createAction(CurrentScorecardActions.CLEAR_CURRENT_SCORECARD);
    //         })
    //     )
    // );


    logout$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SessionActions.LOGOUT),
            map(() => {
                // alert("CurrentScorecardEffects_logout")

                return createAction(CurrentScorecardActions.CLEAR_CURRENT_SCORECARD);
            })
        )
    );


}